import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '~/reducers';
import { initRemoteConfig, refetchWithSignals } from '~/config/firebase/remote-config';
import { useNetworkStatus } from '~/hooks/use-network-status';

const useRemoteConfig = () => {
  const online = useNetworkStatus();
  const { analyticsReported } = useSelector((state: AppState) => state.app);
  const { diamGroupId } = useSelector((state: AppState) => state.authentication);

  useEffect(() => {
    const customSignals: Record<string, string> = {};
    if (diamGroupId) {
      customSignals.diamGroupId = diamGroupId;
    }
    const hasSignals = Object.keys(customSignals).length > 0;

    if (analyticsReported && online && hasSignals) {
      void refetchWithSignals(customSignals);
    } else {
      void initRemoteConfig(hasSignals ? customSignals : undefined);
    }
  }, [online, analyticsReported, diamGroupId]);
};

export { useRemoteConfig };
